var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseSquare = function SvgCloseSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 37 36",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1 12.4a1.25 1.25 0 0 1 0 1.768L14.668 23.6a1.25 1.25 0 1 1-1.768-1.768l9.434-9.433a1.25 1.25 0 0 1 1.768 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9 12.4a1.25 1.25 0 0 1 1.767 0l9.434 9.433a1.25 1.25 0 1 1-1.768 1.768l-9.434-9.433a1.25 1.25 0 0 1 0-1.768Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.658 3.158C5.882.934 9.21.083 13.5.083h10c4.29 0 7.618.85 9.842 3.075C35.566 5.382 36.417 8.71 36.417 13v10c0 4.29-.85 7.618-3.075 9.842-2.224 2.224-5.552 3.075-9.842 3.075h-10c-4.29 0-7.618-.85-9.842-3.075C1.434 30.618.583 27.29.583 23V13c0-4.29.85-7.618 3.075-9.842Zm1.768 1.768C3.9 6.452 3.083 8.956 3.083 13v10c0 4.044.817 6.549 2.343 8.075 1.525 1.525 4.03 2.342 8.074 2.342h10c4.043 0 6.549-.817 8.074-2.342 1.526-1.526 2.343-4.031 2.343-8.075V13c0-4.043-.817-6.548-2.343-8.074C30.05 3.4 27.544 2.583 23.5 2.583h-10c-4.043 0-6.549.817-8.074 2.343Z",
    fill: "currentColor"
  })));
};
export default SvgCloseSquare;